import React from 'react'
import { SelectItems } from './SelectItems'
import type { SelectItem } from './SelectItems'

interface DropdownProps {
  id: string
  label?: string
  items: SelectItem[]
  onChange?: React.ChangeEventHandler<HTMLSelectElement>
}

export const Dropdown: React.FC<DropdownProps> = ({ id, label, items, onChange }) => {
  return (
    <div className='dropdown'>
      <label>
        {label}
        <SelectItems id={id} items={items} onChange={onChange} />
      </label>
    </div>
  )
}
